import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Button,
	Typography,
	Grid,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
	FileCopy as CopyIcon,
} from '@material-ui/icons';
import _ from 'lodash';


import { MyPATIconButton, MyPATDialog, MyPATSelect } from '../../common';
import ContentData from '../types/ContentData';
import { UserData } from '../types/ContentData';


const styles = (theme: Theme) => createStyles({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
		width: '95%',
	},
	author: {
		margin: '30px auto 20px',
		display: 'block',
	}

});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};


//@ts-ignore
interface Props extends WithStyles<typeof styles> {
	classes: any,
	isReviwerDialogOpen: boolean,
	onReviewSelected: Function,
}
interface States {
	selectedUser: string,
	reviwerList: any[]
}

class ContentReviwerModal extends Component<Props, States> {
	state = {
		selectedUser: "",
		reviwerList: [],
	};

	constructor(props: Props) {
		super(props);

		this.onAuthorSelected = this.onAuthorSelected.bind(this);
	}


	componentDidMount() {
		// let reviwerList: any = ACLService.getUserReviewer();
		// if (reviwerList && reviwerList.length > 0) {
		// 	this.setState({ reviwerList });
		// }

	}

	selectReviver = (event: any) => {
		this.setState({ selectedUser: event.target.value });
	};



	onAuthorSelected(action: boolean) {
		if (action) {
			this.props.onReviewSelected(action, this.state.selectedUser);
		} else {
			this.props.onReviewSelected(action, null);
		}
	}



	render() {
		const { classes, isReviwerDialogOpen } = this.props;
		const { reviwerList } = this.state;

		return (
			<div>
				<MyPATDialog
					dialogOpen={isReviwerDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					customDialogActions={
						<>
							<Button variant="contained" color="primary" onClick={() => { this.onAuthorSelected(true) }}>Save</Button>

							<Button
								color="primary"
								onClick={() => { this.onAuthorSelected(false) }}>
								Cancel
              </Button>
						</>
					}
				>
					<img src="/assets/img/mylibrary/author.png" className={classes.author} />
					<div className={classes.formControl}>
						<MyPATSelect
							inputId="reviwer"
							name="reviwer"
							fullWidthControl
							onChange={this.selectReviver.bind(this)}
						>
							<option value="">Select Reviewer</option>
							{
								_.map(reviwerList, (reviwer: any, index) =>
									<option key={`reviwer_${index}`} value={_.get(reviwer, '_id', '')}>
										{!_.isEmpty(reviwer.fullName) ? reviwer.fullName : _.get(reviwer, 'firstName lastName', '')}
									</option>
								)}
						</MyPATSelect>
					</div>
				</MyPATDialog>
			</div>
		);
	}
}

// @ts-ignore
export default withStyles(styles)(ContentReviwerModal);